var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEnvelopeWithArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1201 3.11499C13.5343 3.11499 13.8701 3.45078 13.8701 3.86499V7.33795C13.8701 7.75216 13.5343 8.08795 13.1201 8.08795C12.7059 8.08795 12.3701 7.75216 12.3701 7.33795V3.86499C12.3701 3.45078 12.7059 3.11499 13.1201 3.11499Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 12.5C8.25 12.0858 8.58579 11.75 9 11.75H15C15.4142 11.75 15.75 12.0858 15.75 12.5C15.75 12.9142 15.4142 13.25 15 13.25H9C8.58579 13.25 8.25 12.9142 8.25 12.5Z",
    className: "icon-fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4239 9.51988C11.689 9.20167 12.1619 9.15868 12.4802 9.42385L15.4802 11.9239C15.6512 12.0663 15.75 12.2774 15.75 12.5C15.75 12.7226 15.6512 12.9337 15.4802 13.0762L12.4802 15.5762C12.1619 15.8414 11.689 15.7984 11.4239 15.4802C11.1587 15.1619 11.2017 14.689 11.5199 14.4239L13.8285 12.5L11.5199 10.5762C11.2017 10.311 11.1587 9.83809 11.4239 9.51988Z",
    className: "icon-fill"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.24023 3.11499C2.65445 3.11499 2.99023 3.45078 2.99023 3.86499V9.61795C2.99023 9.91094 3.22725 10.148 3.52023 10.148H6.36023C6.77445 10.148 7.11023 10.4837 7.11023 10.898C7.11023 11.3122 6.77445 11.648 6.36023 11.648H3.52023C2.39882 11.648 1.49023 10.7394 1.49023 9.61795V3.86499C1.49023 3.45078 1.82602 3.11499 2.24023 3.11499Z",
    className: "icon-fill"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.52727 3.32788C3.23045 3.32788 2.99023 3.56809 2.99023 3.86492C2.99023 4.04219 3.07856 4.20969 3.22604 4.30962L6.65393 6.63285C7.27344 7.05266 8.08695 7.05268 8.70647 6.63289C8.70645 6.63291 8.7065 6.63288 8.70647 6.63289L12.135 4.30905C12.2826 4.20901 12.3709 4.04263 12.3709 3.86492C12.3709 3.56834 12.1303 3.32788 11.8338 3.32788H3.52727ZM1.49023 3.86492C1.49023 2.73967 2.40202 1.82788 3.52727 1.82788H11.8338C12.9582 1.82788 13.8709 2.73942 13.8709 3.86492C13.8709 4.54093 13.5354 5.17202 12.9766 5.55071C12.9765 5.55073 12.9766 5.55068 12.9766 5.55071L9.54807 7.87455C8.4204 8.63872 6.94013 8.63876 5.81246 7.87459L2.38467 5.55143C2.38464 5.55141 2.3847 5.55145 2.38467 5.55143C1.82565 5.17262 1.49023 4.54009 1.49023 3.86492Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnvelopeWithArrow);
export default __webpack_public_path__ + "static/media/icon-envelope-with-arrow.7abb0f6f16aa6590b6e29e47eded1689.svg";
export { ForwardRef as ReactComponent };